import React from "react";
import { ElectionDayCardSmall } from "./election-day-card-small";

export const BoothGrid = ({ data }: any) => {
    const sortedBooths = Object.entries(data || {}).sort(
        ([a], [b]) => Number(a) - Number(b) // 🔥 numeric sort
    );

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {sortedBooths.map(([key, val]) => (
                <ElectionDayCardSmall key={key} name={key} data={val} />
            ))}
        </div>
    );
};
